export function getBlobFromBase64String(base64String: string, mimeType: string): Blob {
  const bin = atob(base64String.replace(/-/g, '+').replace(/_/g, '/'));
  const len = bin.length;
  const arr = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    arr[i] = bin.charCodeAt(i);
  }
  return new Blob([arr], { type: mimeType });
}

export function getObjectUrlFromBlob(blob: Blob): string {
  return URL.createObjectURL(blob);
}

export function getObjectUrlFromBase64String(base64String: string, mimeType: string): string {
  const blob = getBlobFromBase64String(base64String, mimeType);
  return getObjectUrlFromBlob(blob);
}
